import React, { Component } from 'react';
import dataModel from '../../../models/DataModel';
import MobileHeader from '../../MobileHeader';
import PhotoCarousel from '../../PhotoCarousel';
import PhotoPermissionsUtil from '../../../helpers/permissions/PhotoPermissionsUtil';
import { withRouter } from 'react-router-dom';

import './MobilePhotoDisplay.scss';

const completionStepDescriptor = {
  completion_criteria: {
    attachments: {
      additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
      user: {}, 
    }, 
  },
};
export class MobilePhotoDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialAttachmentId: null,
      completionStep: null,
      task: null,
    };

    this.handleDeletePhoto = this.handleDeletePhoto.bind(this);
  }

  componentDidMount() {
    const { photo_id, completion_step_id, task_id } = this.props.match.params;

    let routerState = this.props.history.getState();
    if (routerState) {
      this.userStepPermissions = this.props.history.getState().userStepPermissions;
    }

    // enable viewport zoom for mobile
    document.querySelector('meta[name=viewport]').setAttribute('content', 'user-scalable=yes, initial-scale=1, maximum-scale=5.0, minimum-scale=1');
    this.forceUpdate();

    const photoId = photo_id == 'all' ? null : +photo_id;
    this.fetchData(completion_step_id, photoId, task_id);
  }

  componentWillUnmount() {
    // disable viewport zoom for mobile
    document.querySelector('meta[name=viewport]').setAttribute('content', 'user-scalable=no, initial-scale=1, maximum-scale=5.0, minimum-scale=1');
  }

  handleGetAttachment(attachment) {
    return dataModel.attachmentsDAO.getAttachment(attachment.id, { recordDescriptor: { attachment: { user: { }, additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at']  } } });
  }
  
  handleGetAttachments(attachments) {
    return Promise.all(attachments.map(attachment => this.handleGetAttachment(attachment)));
  }

  async fetchData(completionStepId, selectedAttachmentId, taskId) {
    this.fetchTask(taskId);
    let completionStep = await dataModel.completionCriteriaDAO.getCompletionCriterion(completionStepId, { recordDescriptor: completionStepDescriptor },
      completionStep => {
        
      });
    if (completionStep){
      if (
        this.props.match.params.photo_id != 'all' && 
        (completionStep && !completionStep.attachments.find(a => a.id == selectedAttachmentId))
      ) {
        this.props.history.goBack();
      }
  
      // completionStep.attachments = await this.handleGetAttachments(completionStep.attachments)
      completionStep.attachments.sort((a1, a2) => {
        return a1.id < a2.id ? -1 : a1.id > a2.id ? 1 : 0;
      });

      let selectedIndex = 0;
      if (selectedAttachmentId) {
        completionStep.attachments.filter((attachment, index) => {
          if (attachment.id == +selectedAttachmentId) {
            selectedIndex = index;
          }
          return attachment.id == +selectedAttachmentId;
        });
      }
      this.setState({
        completionStep, 
        initialAttachmentId: selectedAttachmentId || completionStep.attachments[0].id,
        animateToIndex: selectedIndex,
      });
    }
  }

  async fetchTask(taskId) {
    const task = await dataModel.tasksDAO.getTask(taskId, { recordDescriptor: { task: {} } }, task => {
      this.setState({ task });
    });
    this.setState({ task });
  }

  handleDeletePhoto(attachment) {
    dataModel.attachmentsDAO.deleteAttachment(attachment.id)
      .then(() => this.props.history.goBack());
  }

  render() {
    const { completionStep, task, initialAttachmentId } = this.state;
    let tempState = this.props.history.getState();
    if (!tempState || !task || !completionStep) {
      return null;
    }

    const fromQuickActions = (this.props.match.params.photo_id == 'all');
    const canUserEditPhoto = PhotoPermissionsUtil.canUserEditPhoto(this.userStepPermissions, completionStep, task);
    return (
      <div className="mobile-wrapper"> 
        <MobileHeader
          headerTitle={ (fromQuickActions ? 'Tasks' : 'Completion Step Detail') } 
          useDoneButton={!fromQuickActions}
        />
        <div className="content-wrapper">
          <PhotoCarousel
            attachments={completionStep.attachments}
            completionStep={completionStep}
            initialAttachmentId={initialAttachmentId}
            parentDelete={true}
            handleDelete={this.handleDeletePhoto}
            hasDelete={canUserEditPhoto}
            hasRename={canUserEditPhoto}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(MobilePhotoDisplay);



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/MobilePhotoDisplay/index.js